import environments from "../environment";

const APP_SOURCE = "whalelo-admin";
const MAX_QUEUE = 50;
const FLUSH_MS = 5000;
const FLUSH_AT = 20;

type ClientLogEvent = {
	message: string;
	stack?: string;
	url?: string;
	userAgent?: string;
	userId?: number;
	extra?: Record<string, unknown>;
};

function getPostUrl(): string {
	const base = (environments.apiRoot || "").replace(/\/+$/, "");
	return base ? `${base}/client-logs` : "";
}

let queue: ClientLogEvent[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

function flush(): void {
	const url = getPostUrl();
	if (!url || queue.length === 0) return;
	const batch = queue.splice(0, MAX_QUEUE);
	const cid =
		typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
			? crypto.randomUUID()
			: `${Date.now()}-${Math.random()}`;
	void fetch(url, {
		method: "POST",
		mode: "cors",
		headers: {
			"Content-Type": "application/json",
			"X-Correlation-ID": cid,
		},
		body: JSON.stringify({ appSource: APP_SOURCE, events: batch }),
		keepalive: true,
	}).catch(() => {
		/* ignore */
	});
}

function schedule(): void {
	if (timer) return;
	timer = setTimeout(() => {
		timer = null;
		flush();
	}, FLUSH_MS);
}

export function installClientLogger(): void {
	if (typeof window === "undefined") return;

	window.addEventListener("error", (ev: ErrorEvent) => {
		queue.push({
			message: ev.message || "error",
			stack: ev.error?.stack,
			url: window.location.href,
			userAgent: navigator.userAgent,
			extra: { filename: ev.filename, lineno: ev.lineno, colno: ev.colno },
		});
		if (queue.length >= FLUSH_AT) flush();
		else schedule();
	});

	window.addEventListener("unhandledrejection", (ev: PromiseRejectionEvent) => {
		const r = ev.reason;
		queue.push({
			message: String(r?.message || r || "unhandledrejection"),
			stack: typeof r?.stack === "string" ? r.stack : undefined,
			url: window.location.href,
			userAgent: navigator.userAgent,
			extra: { type: "unhandledrejection" },
		});
		if (queue.length >= FLUSH_AT) flush();
		else schedule();
	});

	window.addEventListener("beforeunload", () => {
		flush();
	});
}
